module.exports = __webpack_public_path__ + "static/media/help_icon_black.74325b89.svg";